export default __webpack_public_path__ + "static/media/speedy.d44a120c.svg";